import { createContext, useContext } from 'react';

/**
 * Context that lets child components (e.g. ChatScreen) portal action buttons
 * into the TopBar's actions area without prop-drilling through the tree.
 *
 * TopBar registers the actions slot element via `setEl`; sections read `el`
 * and use `ReactDOM.createPortal` to render their buttons there.
 */
export interface TopBarSlotContextValue {
  /** The DOM element acting as the portal target inside TopBar's actions area. */
  el: HTMLDivElement | null;
  /** Called by TopBar to register (or unregister on unmount) the slot element. */
  setEl: (el: HTMLDivElement | null) => void;
}

export const TopBarSlotContext = createContext<TopBarSlotContextValue>({
  el: null,
  setEl: () => undefined,
});

/** Convenience hook for reading the TopBar actions slot context. */
export function useTopBarSlot(): TopBarSlotContextValue {
  return useContext(TopBarSlotContext);
}
